import React from "react";
import { useExpanded, useSortBy, useTable } from "react-table";
import styles from "./styles/Billing.module.css";
import UserTransactions from "./UserTransactions";
export function BillingTable({
  columns,
  data,
  filter,
  setFilter,
  handleChange,
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy, useExpanded);
  const handleSort = (value) => {
    console.log(value);
    if (value === "Time") value = "date";
    let sort = filter.sort.split("-");
    switch (sort.length) {
      case 1:
        if (sort[0] === "") {
          handleChange(value, "sort");
        } else if (sort[0] === value) {
          handleChange("-" + value, "sort");
        } else {
          handleChange(value, "sort");
        }
        break;
      case 2:
        if (sort[1] === value) {
          handleChange("", "sort");
        } else {
          handleChange(value, "sort");
        }
        break;
      default:
        break;
    }
  };
  return (
    <>
      <table {...getTableProps()} className={styles.sub_table_div}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr
              key={i}
              className={styles.head_row}
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column, i) => (
                <th
                  key={i}
                  className={styles.th}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  <div className={styles.header}>
                    <span
                      onClick={() => {
                        handleSort(column.id);
                      }}
                    >
                      {column.render("Header")}
                    </span>
                    {filter.sort.includes(column.id) ? (
                      filter.sort.includes("-") ? (
                        <div className={styles.sort_down}></div>
                      ) : (
                        <div className={styles.sort_up}></div>
                      )
                    ) : column.id === "action" ? null : (
                      <div className={styles.sort_neutral}></div>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <>
                <React.Fragment key={row.getRowProps().key}>
                  <tr className={styles.row}>
                    {row.cells.map((cell) => {
                      return (
                        <td
                          className={styles.td}
                          {...cell.getCellProps()}
                          {...row.getToggleRowExpandedProps({
                            title: undefined,
                          })}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                  {row.isExpanded ? (
                    <tr style={{ width: "100%" }}>
                      <td colSpan={row.cells.length}>
                        <UserTransactions customer_id={1} />
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              </>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
